import dayjs from 'dayjs';
import classNames from 'classnames';
import { msgid, ngettext, t } from 'ttag';

import { smartLanding } from '@urls';
import { useTimer } from '@hook/useTimer';
import { Button } from '@ui/Button';
import { SmartIcon } from '@components/SmartIcon';
import { AnimatedPageBanner } from '@components/AnimatedPageBanner';

import s from './AnimatedSmartBanner.sss';

interface Props {
  className?: string,
  description?: string | null,
  availableUntilTheTime?: string | null,
  onClose: () => void,
}

export const AnimatedSmartBanner: React.FC<Props> = ({
  className,
  description,
  availableUntilTheTime,
  onClose,
}) => {
  const { duration } = useTimer({
    initialStart: true,
    initialTime: dayjs.duration(dayjs(availableUntilTheTime).diff()),
  });

  const daysCount = Math.floor(duration.asDays());
  const countDown = duration.format('HH:mm:ss');
  const daysText = ngettext(
    msgid`${daysCount} день`,
    `${daysCount} дні`,
    `${daysCount} днів`,
    daysCount,
  );

  const isTimerActive = !!availableUntilTheTime && !dayjs().isAfter(dayjs(availableUntilTheTime));
  const timerText = daysCount > 0 ? daysText : countDown;

  return (
    <AnimatedPageBanner
      rootClassName={className}
      containerClassName={s.container}
      isVisible={true}
      onClose={onClose}
    >
      <div className={s.banner}>
        <p className={s.badge}>
          <SmartIcon
            className={s.icon}
            size="32"
          />
          <span className={s.name}>
            Smart
          </span>
        </p>

        <p className={s.title}>
          {t`Безкоштовна доставка SMART`}
        </p>

        <p
          className={classNames(s.description, {
            [s.descriptionTypeBold]: isTimerActive,
          })}
        >
          {isTimerActive
            ? t`До кінця акції ${timerText}`
            : description}
        </p>

        <Button
          className={s.button}
          theme="secondary"
          href={smartLanding}
          onClick={onClose}
        >
          {t`Деталі`}
        </Button>
      </div>
    </AnimatedPageBanner>
  );
};
